import React from 'react';
import queryString from 'query-string';

import './styles.scss';
import Logo from 'assets/logo-dysmate.png';
import createTest from 'api/createTest';

const parsedSearch = queryString.parse(window.location.search);
const error = parsedSearch.error;

class LandingPageFeide extends React.Component {
	constructor() {
		super();

		this.state = {
			error: null,
			isCreatingTestKey: false,
		};
	}

	componentDidMount() {
		if (localStorage.getItem('authtoken-screening')) {
			localStorage.removeItem('authtoken-screening');
		}
	}

	generateTestKeyOnFly() {
		const type = 'adult-screening';

		this.setState({
			error: null,
			isCreatingTestKey: true,
		});

		createTest(type)
			.then((res) => {
				const result = Array.isArray(res) ? res[0] : res;

				if (result && result.keyString) {
					window.location.href = `/signon?key=${result.keyString}`;
					return;
				}

				this.setState({
					error: 'Kunne ikke opprette testnøkkel',
					isCreatingTestKey: false,
				});
			})
			.catch(() => {
				this.setState({
					error: 'Kunne ikke opprette testnøkkel',
					isCreatingTestKey: false,
				});
			});
	}

	startFeideLogin = () => {
		const existingKey = parsedSearch.key;

		if (existingKey) {
			window.location.href = `/signon?key=${existingKey}`;
			return;
		}

		this.generateTestKeyOnFly();
	};

	render() {
		const {isCreatingTestKey} = this.state;
		const errorMessage =
			this.state.error ||
			(error ? 'En gyldig nøkkel kreves for å logge inn' : null);

		return (
			<div>
				<header className="lit-header">
					<h1 className="lit-logo">
						<img
							className="lit-logo__img"
							src={Logo}
							alt="Literate Logo"
						/>
					</h1>

					<div className="right">
						<a className="lit-link" href="http://admin.literate.no">
							Administrator
						</a>
					</div>
				</header>
				<h1 className="lit-page-title">Screeningtest</h1>
				<p className="lit-page-description">
					Trykk på start knappen for å logge på med Feide
				</p>
				<div className="lit-wrapper--article">
					<form
						onSubmit={(e) => {
							e.preventDefault();
							this.startFeideLogin();
						}}
					>
						<div className="lit-input inline">
							<div className="lit-page-description">
								<button
									className="lit-btn bg-secondary"
									disabled={isCreatingTestKey}
								>
									{isCreatingTestKey ? 'Starter...' : 'Start'}
								</button>
							</div>
						</div>
						{Boolean(errorMessage) && (
							<span className="lit-error-message">
								{errorMessage}
							</span>
						)}
					</form>
				</div>
			</div>
		);
	}
}

export default LandingPageFeide;
